export default __webpack_public_path__ + "static/media/6.2e0e15c4.jpg";